// Activity Log — the screen's strings in the portal's four languages (2026-10-21). Action codes, actors,
// entity ids and the old / new values come from the audit log and are not in here.
const en = {
  viaScreen: 'Portal screen',
  viaCatchy: 'Catchy Chat',
  viaSystem: 'System (job)',
  viaNone: 'door not recorded (before 30/Oct)',
  mod: {
    projectTracker: 'Project Tracker',
    sampleTracker: 'Sample Tracker',
    ticketStation: 'Ticket Station',
    nfcPortal: 'NFC Portal',
    portalAdmin: 'Admin / Roles',
    spHub: 'Style Hub',
    cashReport: 'Cash Report',
    sopWeekly: 'Sales Op Weekly Report',
  },
  loadFailed: 'Failed to load activity log.',
  title: 'Activity Log',
  sub: 'Changes and actions for the functions you have access to.',
  back: 'Back',
  reload: 'Reload',
  viewLog: 'Activity', viewDeleted: 'Deleted items', deletedTag: 'Deleted', delKind: 'What', kind_sample_round: 'Sample round', kind_sku: 'SKU', kind_project: 'Project',
  delSearch: 'Search an ID, name or who deleted it…', delCount: '{{n}} kept', delShow: 'Show data', delHide: 'Hide', delNone: 'Nothing deleted yet.',
  delHint: 'A sample round, SKU or project deleted on the trackers is kept here as it was, with who and when (since 30/Oct). Nobody can change or remove these.',
  searchPh: 'Search actor, entity or detail…',
  allAreas: 'All areas',
  allActions: 'All actions',
  clear: 'Clear',
  count: '{{shown}} of {{total}}',
  col: {
    time: 'Time',
    area: 'Area',
    action: 'Action',
    by: 'By',
    entity: 'Entity',
    field: 'Field',
    oldValue: 'Old value',
    newValue: 'New value',
  },
  empty: 'No activity to show.',
  loading: 'Loading…',
  loadMore: 'Load more ({{n}} left)',
};

const ko = {
  viaScreen: '포털 화면',
  viaCatchy: 'Catchy Chat',
  viaSystem: '시스템 (작업)',
  viaNone: '경로 기록 없음 (10/30 이전)',
  mod: {
    projectTracker: '프로젝트 트래커',
    sampleTracker: '샘플 트래커',
    ticketStation: '티켓 스테이션',
    nfcPortal: 'NFC 포털',
    portalAdmin: '관리 / 역할',
    spHub: 'Style Hub',
    cashReport: '현금 보고서',
    sopWeekly: 'Sales Op 주간 보고서',
  },
  loadFailed: '활동 로그를 불러오지 못했습니다.',
  title: '활동 로그',
  sub: '접근 권한이 있는 기능의 변경 사항과 작업입니다.',
  back: '뒤로',
  reload: '새로고침',
  viewLog: '활동', viewDeleted: '삭제된 항목', deletedTag: '삭제됨', delKind: '종류', kind_sample_round: '샘플 라운드', kind_sku: 'SKU', kind_project: '프로젝트',
  delSearch: 'ID, 이름 또는 삭제한 사람 검색…', delCount: '{{n}}건 보관', delShow: '데이터 보기', delHide: '닫기', delNone: '삭제된 항목이 없습니다.',
  delHint: '트래커에서 삭제한 샘플 라운드, SKU, 프로젝트는 삭제한 사람과 시간과 함께 그대로 여기에 보관됩니다(10/30부터). 누구도 수정하거나 지울 수 없습니다.',
  searchPh: '작업자, 대상 또는 내용 검색…',
  allAreas: '전체 영역',
  allActions: '전체 작업',
  clear: '해제',
  count: '{{total}}건 중 {{shown}}건',
  col: {
    time: '시간',
    area: '영역',
    action: '작업',
    by: '작업자',
    entity: '대상',
    field: '항목',
    oldValue: '이전 값',
    newValue: '새 값',
  },
  empty: '표시할 활동이 없습니다.',
  loading: '불러오는 중…',
  loadMore: '더 보기 ({{n}}건 남음)',
};

const vi = {
  viaScreen: 'Màn hình portal',
  viaCatchy: 'Catchy Chat',
  viaSystem: 'Hệ thống (tác vụ)',
  viaNone: 'chưa ghi kênh (trước 30/Oct)',
  mod: {
    projectTracker: 'Theo dõi dự án',
    sampleTracker: 'Theo dõi mẫu',
    ticketStation: 'Ticket Station',
    nfcPortal: 'Cổng NFC',
    portalAdmin: 'Quản trị / Vai trò',
    spHub: 'Style Hub',
    cashReport: 'Báo cáo tiền mặt',
    sopWeekly: 'Báo cáo tuần Sales Op',
  },
  loadFailed: 'Không tải được nhật ký hoạt động.',
  title: 'Nhật ký hoạt động',
  sub: 'Các thay đổi và thao tác trên những chức năng bạn có quyền truy cập.',
  back: 'Quay lại',
  reload: 'Tải lại',
  viewLog: 'Hoạt động', viewDeleted: 'Mục đã xoá', deletedTag: 'Đã xoá', delKind: 'Loại', kind_sample_round: 'Vòng sample', kind_sku: 'SKU', kind_project: 'Project',
  delSearch: 'Tìm mã, tên hoặc người xoá…', delCount: 'Đang giữ {{n}} mục', delShow: 'Xem dữ liệu', delHide: 'Ẩn', delNone: 'Chưa có mục nào bị xoá.',
  delHint: 'Vòng sample, SKU hay project bị xoá trên tracker được giữ nguyên ở đây, kèm người xoá và thời gian (từ 30/Oct). Không ai sửa hay xoá được các mục này.',
  searchPh: 'Tìm người thực hiện, đối tượng hoặc chi tiết…',
  allAreas: 'Tất cả phân hệ',
  allActions: 'Tất cả thao tác',
  clear: 'Xóa',
  count: '{{shown}} / {{total}}',
  col: {
    time: 'Thời gian',
    area: 'Phân hệ',
    action: 'Thao tác',
    by: 'Người thực hiện',
    entity: 'Đối tượng',
    field: 'Trường',
    oldValue: 'Giá trị cũ',
    newValue: 'Giá trị mới',
  },
  empty: 'Không có hoạt động nào để hiển thị.',
  loading: 'Đang tải…',
  loadMore: 'Tải thêm (còn {{n}})',
};

const zh = {
  viaScreen: '门户页面',
  viaCatchy: 'Catchy Chat',
  viaSystem: '系统（任务）',
  viaNone: '未记录途径（10/30 之前）',
  mod: {
    projectTracker: '项目跟踪',
    sampleTracker: '样品跟踪',
    ticketStation: '工单中心',
    nfcPortal: 'NFC 门户',
    portalAdmin: '管理 / 角色',
    spHub: 'Style Hub',
    cashReport: '现金报告',
    sopWeekly: 'Sales Op 周报',
  },
  loadFailed: '无法加载操作日志。',
  title: '操作日志',
  sub: '您有权访问的功能中的更改和操作。',
  back: '返回',
  reload: '重新加载',
  viewLog: '活动', viewDeleted: '已删除项目', deletedTag: '已删除', delKind: '类型', kind_sample_round: '样品轮次', kind_sku: 'SKU', kind_project: '项目',
  delSearch: '搜索编号、名称或删除人…', delCount: '保留 {{n}} 项', delShow: '查看数据', delHide: '收起', delNone: '尚无删除记录。',
  delHint: '在追踪表中删除的样品轮次、SKU 或项目会原样保留在这里，并记录删除人和时间（自 10/30 起）。任何人都无法修改或移除。',
  searchPh: '搜索操作人、对象或详情…',
  allAreas: '全部模块',
  allActions: '全部操作',
  clear: '清除',
  count: '{{shown}} / {{total}}',
  col: {
    time: '时间',
    area: '模块',
    action: '操作',
    by: '操作人',
    entity: '对象',
    field: '字段',
    oldValue: '旧值',
    newValue: '新值',
  },
  empty: '暂无操作记录。',
  loading: '加载中…',
  loadMore: '加载更多（剩余 {{n}} 条）',
};

const dictionary = { ns: 'xActivity', en, ko, vi, zh };

export default dictionary;
